import history from "./history";

export const concatUriPath = (...args) =>
  `/${args.join("/").replace(/\/$/, "")}`;

export const setUriPath = (lang, seed, level, secret, push = false) => {
  const path = concatUriPath(lang, seed, level, secret);

  if (push) {
    history.push(path);
  } else {
    history.replace(path);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/uri.js